<template>
  <v-speed-dial
    id="global-tools"
    v-model="fab"
    bottom
    right
    fixed
    direction="top"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        color="accent"
        fab
      >
        <v-icon v-if="fab">
          close
        </v-icon>
        <v-icon v-else>
          build
        </v-icon>
      </v-btn>
    </template>

    <v-tooltip
      v-for="tool in tools"
      :key="`tool-${tool.title}`"
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :id="`global-tools-${tool.id}`"
          fab
          small
          color="primary"
          v-on="on"
          @click="tool.onClick"
        >
          <v-icon>{{ tool.icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tool.title }}</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      fab: false
    }
  },
  computed: {
    ...mapGetters('user', [ 'preferences' ]),
    tools () {
      return [
        // {
        //   title: 'Currency Converter',
        //   icon: 'euro_symbol',
        //   value: this.preferences.currencyConversion,
        //   onClick: this.toggleConvertCurrency
        // },
        // {
        //   id: 'recent-documents',
        //   title: 'Recent Documents',
        //   icon: 'insert_drive_file',
        //   onClick: this.openDocumentsMenu
        // },
        {
          id: 'help',
          title: 'Help',
          icon: 'help',
          onClick: this.openContextualHelp
        }
      ]
    }
  },
  methods: {
    ...mapMutations('documents', [ 'showDocumentsMenu' ]),
    ...mapMutations('help', [ 'showContextualHelp' ]),
    ...mapMutations('user', [ 'setPreferences' ]),

    toggleConvertCurrency () {
      if (this.preferences.currencyConversion) {
        this.setPreferences({ currencyConversion: null })
      } else {
        this.setPreferences({ currencyConversion: 'USD' })
      }
    },
    openContextualHelp () {
      this.showContextualHelp(true)
    },
    openDocumentsMenu () {
      this.showDocumentsMenu(true)
    }
  }
}
</script>

<style>

</style>
